import React from "react";
import "./App.css";
import "./styles/luxury-design.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhyChoose from "./components/WhyChoose";
import LimitedTimeNotice from "./components/LimitedTimeNotice";
import EmailSubscribe from "./components/EmailSubscribe";
import AppointmentBooking from "./components/AppointmentBooking";
import TaxAppDownload from "./components/TaxAppDownload";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import AdminDashboard from "./pages/AdminDashboard";

const HomePage = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToAppointments = () => {
    const element = document.getElementById('appointments');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div style={{ background: 'var(--bg-primary)' }}>
      <Header />
      <Hero onGetStarted={scrollToAppointments} onContactUs={scrollToContact} />
      <div id="services">
        <Services />
      </div>
      <WhyChoose />
      <LimitedTimeNotice />
      <EmailSubscribe />
      <AppointmentBooking />
      <TaxAppDownload />
      <ContactForm />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App" style={{ background: 'var(--bg-primary)' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;